// Centrale Nederlandse auth-teksten. Eén bron zodat UX-copy consistent blijft.

export const SESSIE_VERLOPEN = "Je sessie is verlopen. Meld je opnieuw aan.";
export const AUTH_VEREIST = "Authenticatie vereist. Meld je aan om verder te gaan.";
export const GEEN_TOEGANG_PAGINA = "Je hebt geen toegang tot deze pagina.";
export const GEEN_TOEGANG_APP = "Je account heeft geen toegang tot deze applicatie.";
export const AANMELDEN_MISLUKT_LOOP =
  "Aanmelden lukt niet. Mogelijk heeft je account geen toegang. Meld je af en probeer een ander account.";
// Technische fout (netwerk, timeout, 5xx, token nog niet beschikbaar): herstelbaar
// en nadrukkelijk GEEN uitspraak over rechten. Nooit GEEN_TOEGANG_APP hiervoor
// gebruiken: die vermenging maakte een tijdelijke storing zichtbaar als weigering.
export const AUTH_CONTROLE_MISLUKT =
  "We konden je toegang niet controleren. Controleer je verbinding en probeer opnieuw.";
export const OPNIEUW_PROBEREN = "Opnieuw proberen";

// Hint-teksten voor apiClient foutmeldingen (voorheen Engels).
export const HINT_401 = "Niet aangemeld. Meld je opnieuw aan.";
export const HINT_403 = "Toegang geweigerd.";
export const HINT_502 =
  "De market data engine is niet bereikbaar. Probeer het later opnieuw of controleer of de engine draait.";
export const HINT_5XX = "Interne serverfout. Probeer het later opnieuw.";
